import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import UseAPI from 'lib/api/UseAPI';
import api_config from 'lib/api/common';

const Auth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkUserToken = () => {

    const params = new URLSearchParams(location.search);
    const nextUrl = params.get('next');

    const loggedIn = localStorage.getItem('loggedIn');

    if (!loggedIn || loggedIn === 'undefined') {
      setIsLoggedIn(false);
      if (nextUrl) {
        navigate('/login?next=' + nextUrl);
        return;
      }
      navigate('/login');
      return;
    }

    // Verify token with backend
    let url = api_config.BASE_BACKEND_ENDPOINT + 'api/my-profile/';
    let apiController = new AbortController();
    const signal = apiController.signal;

    UseAPI(signal, url, 'GET', {})
      .then(function (result) {
        if (result.code === 200) {
          setIsLoggedIn(true);
          if (nextUrl) {
            navigate(nextUrl);
          }
          else {
            navigate('/');
          }
        } else {
          // Token invalid or backend rejected
          throw new Error("Invalid session");
        }
      })
      .catch(function (err) {
        // Backend unreachable or token invalid -> Stay on login
        console.log("Session verification failed:", err);
        localStorage.clear();
        setIsLoggedIn(false);
        navigate('/login');
      });
  };

  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn]);
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};
export default Auth;
